import script from "./CatalogSearchInputSuggestions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogSearchInputSuggestions.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogSearchInputSuggestions.vue?vue&type=style&index=0&id=31a8e8f7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a8e8f7"]])

export default __exports__